module.exports = __webpack_public_path__ + "static/media/pause_nofm.9f42da90.svg";